import React from "react";
import Slider from "react-slick";
import ReactPlayer from "react-player/youtube";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const LearnVideos = ({ playlists, channel }) => {
  const settings = {
    className: "center",
    dots: true,
    infinite: true,
    speed: 500,
    centerMode: true,
    centerPadding: "0px",
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          centerPadding: "250px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          centerPadding: "30px",
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div id="learn-videos" className="videos">
      <div className="learn-videos__playlist d-flex flex-column align-items-center">
        <div className="d-flex justify-content-center">
          <h2>Videos</h2>
        </div>
        <div className="slider-wrapper">
          <Slider {...settings}>
            {playlists.map(
              ({ acfYoutube: { link, caption, duration, date } }, i) => (
                <div
                  className="slider-item d-flex flex-column justify-content-center"
                  key={`video-${i}`}
                  index={i + 1}
                >
                  <div className="player-wrapper">
                    <ReactPlayer
                      className="player mx-auto text-center"
                      url={link}
                      light={true}
                      width="100%"
                      height="100%"
                    />
                  </div>
                  <div className="player-description">
                    <p className="h3 mb-1 mb-md-4">{caption}</p>
                    <small>
                      {date} &bull; {duration} min
                    </small>
                  </div>
                </div>
              )
            )}
          </Slider>
        </div>
      </div>

      <div className="learn-videos__subscribe d-flex flex-wrap justify-content-center align-items-center">
        <div>
          <img className="img-fluid" src={channel.pIcon.localFile.publicURL} />
        </div>
        <div className="d-flex flex-column text-center">
          <h2>{channel.pHeading}</h2>
          <a
            className="learn-videos__subscribe-button mt-3 mx-3 mx-md-0"
            href={channel.pButtonUrl}
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            {channel.pButtonText}
          </a>
        </div>
      </div>
    </div>
  );
};

export default LearnVideos;
